export default "__VITE_ASSET__749ff239__"